import compo  from './components';
import grid   from  './grid';

import direc  from './directives';
import filter from './filters';
import VueNoti from 'vue-notification';

const uidevComponent = {
    install(Vue){
        Vue.use(VueNoti);
        Vue.use(compo);
        Vue.use(direc);
        Vue.use(filter);
    }
};
export default uidevComponent;

const uidevGrid = {
    install(Vue){
        Vue.use(grid);
    }
};

import validator from './mixins/urValidator/urValidator.js'
import urDataSet from './grid/urDataGrid/util/urDataSet'
const urValidator = validator
export {urValidator, urDataSet, validator, uidevGrid}



